export default __webpack_public_path__ + "static/media/s3.323ebcbe.jpg";